export const SubscribeAccount = {
  Level0: 0,
  Level1: {
    Customer: 500,
    Rule: 799,
    Mass: 599,
    All: 1399,
  },
  Level2: {
    Customer: 1000,
    Rule: 2199,
    Mass: 1999,
    All: 3399,
  },
  Level3: {
    Customer: 3000,
    Rule: 3199,
    Mass: 2999,
    All: 7399,
  },
};

export const ServiceAccount = {
  Level0: 0,
  Level1: {
    Customer: 1000,
    Rule: 2199,
    Mass: 1199,
    All: 2999,
  },
  Level2: {
    Customer: 2000,
    Rule: 4199,
    Mass: 3199,
    All: 6999,
  },
  Level3: {
    Customer: 5000,
    Rule: 6199,
    Mass: 5199,
    All: 13999,
  },
};

export const FansLevel = {
  Level0: 0,
  Level1: 1,
  Level2: 2,
  Level3: 3,
  Level4: 4,
};

export const FansLevelNum = [
  {name: 'level0', value: 0},
  {name: 'level1', value: 1},
  {name: 'level2', value: 2},
  {name: 'level3', value: 3},
  {name: 'level4', value: 4},
];

export const Module = {
  Customer: 'customer',
  Rule: 'rule',
  Mass: 'mass',
};

export const Time = {
  OneYear: 1,
  TwoYear: 2,
  ZeroYear: 0,
};

export const Pay = {
  Wx: 1,
  AliPay: 2,
};
